<template>
  <div class="headerbox">
    <div class="headermain">
    <!-- {{ dataList }} -->
      <div class="logo">
      <img src="../../assets/image/LOGO.png" alt="">
      </div>
      <div class="header">
        <div class="headertit">
          <!-- <el-menu router :default-active="$route.path" class="el-menu-demo" mode="horizontal" background-color="#FFFFFF" text-color="#172B4D" active-text-color="#0052CC">
            <template v-for="menu in dataList">
              <template v-if="!menu.children">
                <el-menu-item :key="menu.id" :index="menu.link">
                  <span v-if="language === 0 && parseInt(menu.zhIsShow) === 1 ">{{menu.zhName}}</span>
                  <span v-if="language === 1 && parseInt(menu.enIsShow) === 1 ">{{menu.enName}}</span>
                </el-menu-item>
              </template>
              <template v-if="menu.children">
                <el-submenu :key="menu.id" :index="menu.link">
                  <template #title>
                    <span v-if="language === 0 && parseInt(menu.zhIsShow) === 1 ">{{menu.zhName}}</span>
                    <span v-if="language === 1 && parseInt(menu.enIsShow) === 1 ">{{menu.enName}}</span>
                  </template>
                  <el-menu-item v-for="subMenu in menu.children" :key="subMenu.id" :index="subMenu.link">
                    <span v-if="language === 0 && parseInt(subMenu.zhIsShow) === 1 ">{{subMenu.zhName}}</span>
                    <span v-if="language === 1 && parseInt(subMenu.enIsShow) === 1 ">{{subMenu.enName}}</span>
                  </el-menu-item>
                </el-submenu>
              </template>
            </template>
          </el-menu> -->
          <template v-for="menu in dataList">
            <template v-if="!menu.children">
              <div class="elmenu" :key="menu.id" @click="goPath(menu.link)">
                <p v-if="language === 0 && parseInt(menu.zhIsShow) === 1 "  :class="act==menu.link?'actMenu':''">{{menu.zhName}}</p>
                <p v-if="language === 1 && parseInt(menu.enIsShow) === 1 "  :class="act==menu.link?'actMenu':''">{{menu.enName}}</p>
              </div>
            </template>
            <template v-if="menu.children">
              <el-dropdown :key="menu.id" class="custom-dropdown" placement="bottom-start">
                <div class="elmenu">
                  <span v-if="language === 0 && parseInt(menu.zhIsShow) === 1 " :class="act==menu.link?'actMenu':''">{{menu.zhName}} <i class="el-icon-arrow-down el-icon--right"></i></span>
                  <span v-if="language === 1 && parseInt(menu.enIsShow) === 1 " :class="act==menu.link?'actMenu':''">{{menu.enName}} <i class="el-icon-arrow-down el-icon--right"></i></span>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="subMenu in menu.children" :key="subMenu.id" :index="subMenu.link">
                    <span v-if="language === 0 && parseInt(subMenu.zhIsShow) === 1 " @click="goPath(subMenu.link)">{{subMenu.zhName}}</span>
                    <span v-if="language === 1 && parseInt(subMenu.enIsShow) === 1 " @click="goPath(subMenu.link)">{{subMenu.enName}}</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </div>
        <!-- <div class="lang" @click="langSwitch">
          <img v-if="language === 0" src="../../assets/image/english.svg" alt="">
          <img v-if="language === 1" src="../../assets/image/china.svg" alt="">
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getMenutree } from '@/api/home'
export default {
  name: 'NavigationBar',
  data () {
    return {
      dataList: [],
      act: ''
    }
  },
  // created () {
  //   this.getList()
  // },
  mounted () {
    // this.getList()
  },
  computed: {
    language () {
      return this.$store.state.base.language
    },
    languageVal () {
      return this.$store.state.base.languageVal
    }
  },
  watch: {
    language: {
      immediate: true,
      handler: function (newValue, oldValue) {
        this.getList()
        this.djclang()
      }
    },
    '$route' (val, from) {
      // 拿到目标参数 val.query.id 去请求接口
      const path = val.query.link
      if (path && path.includes('/aboutUs')) {
        const currentpath = '/aboutUs'
        this.act = currentpath
      } else if (path && path.includes('/serviceCenter')) {
        const currentpath = '/serviceCenter'
        this.act = currentpath
      } else if (path && path.includes('/productCenter')) {
        const currentpath = '/productCenter'
        this.act = currentpath
      } else if (path && path.includes('/newsCenter')) {
        const currentpath = '/newsCenter'
        this.act = currentpath
      } else {
        this.act = path
      }
    }
  },
  methods: {
    goPath (path) {
      this.$store.commit('base/CHANGE_PATH_STATE', path)
      this.$store.commit('base/CHANGE_PATH_FW', path)
      this.$store.commit('base/CHANGE_PATH_XW', path)
      this.$router.push({
        path: path,
        query: {
          link: path
        }
      })
      if (path.includes('/aboutUs')) {
        const currentpath = '/aboutUs'
        this.act = currentpath
        if (path && document.getElementById(path)) {
          document.getElementById(path).scrollIntoView({ behavior: 'smooth' })
        }
      } else if (path.includes('/serviceCenter')) {
        const currentpath = '/serviceCenter'
        this.act = currentpath
      } else if (path.includes('/productCenter')) {
        const currentpath = '/productCenter'
        this.act = currentpath
      } else if (path.includes('/newsCenter')) {
        const currentpath = '/newsCenter'
        this.act = currentpath
      } else {
        this.act = path
      }
    },
    langSwitch () {
      this.$store.commit('base/CHANGE_NAV_STATE')
    },
    djclang () {
      this.$i18n.locale = this.languageVal
    },
    getList () {
      getMenutree(this.language).then(res => {
        if (res.data.code === 200) {
          this.dataList = res.data.data
        // console.log(this.dataList)
        } else {
          this.dataList = []
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-dropdown{
  font-size: 16px;
  font-weight: 400;
  color: #172B4D;
}
.el-popper {
  overflow: auto;
}
.el-dropdown-menu__item {
  &:hover {
    background-color: #0052CC;
    color: #FFFFFF;
  }
}
.el-menu{
  border-bottom: 0px;
}
::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title{
  font-size: 16px;
  font-weight: 400;
}
::v-deep .el-menu--horizontal>.el-menu-item{
  font-size: 16px;
  font-weight: 400;
}
.el-menu--horizontal>.el-menu-item.is-active{
  font-weight: 900;
  font-size: 16px;
}
.headerbox{
  width: 100%;
  height: 72px;
  background: #FFFFFF;
  box-shadow: 0 2px 6px rgba(0, 0, 0.5, 0.1);
  .headermain{
    font-family: HarmonyOS_Sans_SC_Regular;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo{
      // width: 15px;
      height: 54px;
      // background: #0052CC;
      img{
        // width: 120px;
        height: 54px;
      }
    }
    .header{
      display: flex;
      align-items: center;
      justify-content: start;
      align-items: center;
      .headertit{
        height: 72px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        color: #172B4D;
        cursor: pointer;
        .elmenu{
          margin-right: 30px;
          p,span{
            display: block;
            height: 70px;
            line-height: 72px;
          }
          .subMenu{
            position: absolute;
            bottom: -100px;
            left: center;
            background-color: #FFFFFF;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
        }
        .actMenu{
          // height: 72px;
          font-size: 16px;
          font-weight: 900;
          color: #0052CC;
          border-bottom: 2px solid #0052CC;
        }
      }
      .lang{
        width: 22px;
        height: 22px;
        img{
          width: 22px;
          height: 22px;
        }
      }
    }
  }
}
</style>
